import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import {purchaseStep, purchaseStrategyType} from '../../constants'

export default class PurchaseLightBoxHeader extends TemplateView {
    constructor() {
        super()

        this.state = {
            purchaseStep: purchaseStep.COMPANY_INFO,
            stepNumber: 0,
            totalNumberSteps: 0,
            purchaseStrategyType: '',
        }

        this.onStatePropertyChanged('purchaseStep', () => {
            this.$companyInfo.toggle(this.state.purchaseStep === purchaseStep.COMPANY_INFO)
            this.$accountInfo.toggle(this.state.purchaseStep === purchaseStep.ACCOUNT_INFO)
            this.$payment.toggle(this.state.purchaseStep === purchaseStep.PAYMENT)
            this.$success.toggle(this.state.purchaseStep === purchaseStep.SUCCESS)
        })

        this.onAnyStatePropertyChanged(['purchaseStrategyType', 'stepNumber', 'totalNumberSteps'], () => {
            this.$companyInfo.text(this._getCompanyInfoText())
            this.$accountInfo.text(this._getAccountInfoText())
            this.$payment.text(this._getPaymentText())
        })
    }

    templateHtml() {
        return '<div class="header">' +
               '    <div class="companyInfo"/>' +
               '    <div class="accountInfo"/>' +
               '    <div class="payment"/>' +
               '    <div class="success"></div>' +
               '    <div class="closeButton"/>' +
               '</div>'
    }

    afterRender() {
        this.$companyInfo = this.find('.companyInfo')
        this.$accountInfo = this.find('.accountInfo')
        this.$payment = this.find('.payment')
        this.$success = this.find('.success')

        this.renderInitialState()
    }

    getCloseButtonEl() {
        return this.find('.closeButton')
    }

    _getCompanyInfoText() {
        let text = messageResource.getMessage('licenses.purchase_lightbox.company_info_header',
            [this.state.stepNumber, this.state.totalNumberSteps])

        if (this.state.purchaseStrategyType === purchaseStrategyType.FIRST_FREE) {
            text = messageResource.getMessage('licenses.purchase_lightbox.get_free.company_info_header',
                [this.state.stepNumber, this.state.totalNumberSteps])
        }
        return text
    }

    _getAccountInfoText() {
        let text = messageResource.getMessage('licenses.purchase_lightbox.account_info_header',
            [this.state.stepNumber, this.state.totalNumberSteps])

        if (this.state.purchaseStrategyType === purchaseStrategyType.FIRST_FREE) {
            text = messageResource.getMessage('licenses.purchase_lightbox.get_free.account_info_header',
                [this.state.stepNumber, this.state.totalNumberSteps])
        }
        return text
    }

    _getPaymentText() {
        let text = messageResource.getMessage('licenses.purchase.purchase_lightbox.purchase_step.header_title',
            [this.state.stepNumber, this.state.totalNumberSteps])

        if ((this.state.purchaseStrategyType === purchaseStrategyType.PURCHASE || this.state.purchaseStrategyType === purchaseStrategyType.ADD_USERS) &&
            this.state.totalNumberSteps === 1) {
            text = messageResource.getMessage('licenses.purchase.purchase_step.license_renewal')
        }
        return text
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/PurchaseLightBoxHeader.js